// Stony Brook University's bachelor's majors (#2740). Read on 2026-10-01 from
// the official Fall 2026 Undergraduate Catalog, Majors page
// (catalog.stonybrook.edu, Stony Brook's Modern Campus catalog), which lists the
// majors A to Z with no college, so this is one A to Z group. Degree
// abbreviations are the catalog's. Minors, the Education and Teacher
// Certification combined degree, the online-only Electrical Engineering Online
// (BS) and graduate programs are left out. Clinical Laboratory Sciences,
// Nursing, Respiratory Care and Social Work are upper-division majors that
// students apply to after finishing prerequisites.
const majors = {
    "slug": "stony-brook-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Stony Brook's official Fall 2026 Undergraduate Catalog. Minors, combined degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor's majors",
            "source": {
                "label": "Stony Brook Fall 2026 Undergraduate Catalog, Majors",
                "url": "https://catalog.stonybrook.edu/content.php?catoid=11&navoid=1134"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics and Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Art History and Criticism",
                    "degree": "BA"
                },
                {
                    "name": "Art, Studio",
                    "degree": "BA"
                },
                {
                    "name": "Asian and Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy/Planetary Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Business Management",
                    "degree": "BS"
                },
                {
                    "name": "Chemical and Molecular Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Climate Science",
                    "degree": "BS"
                },
                {
                    "name": "Clinical Laboratory Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Coastal Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BFA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Space Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Ecosystems and Human Impact",
                    "degree": "BA"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Engineering Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BE"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Design, Policy, and Planning",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Globalization Studies and International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Health Science",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Evolutionary Biology",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Marine Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Marine Vertebrate Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mass Communication",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Media/Art/Culture",
                    "degree": "BA"
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Respiratory Care",
                    "degree": "BS"
                },
                {
                    "name": "Rhetoric and Writing",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Technological Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
